<template>
  <div v-if="fileReady">
    <div
      :id="`pdf_${propFileId}`"
      :style="`height: calc(100vh - ${minusHeight}px)`"
    ></div>
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import PDFObject from "pdfobject";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    },
    force: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      PDFJS_URL: "https://res.gosmart.mn/static/pdfobject/web/viewer.html",
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.configure();
  },
  methods: {
    configure() {
      if (
        this.$store.state.app.activeGroup.PDFJS_URL != undefined &&
        this.$store.state.app.activeGroup.PDFJS_URL != ""
      ) {
        this.PDFJS_URL = this.$store.state.app.activeGroup.PDFJS_URL;
      }

      this.init();
    },
    init() {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;

            var options = {
              pdfOpenParams: {
                pagemode: this.$store.state.app.isMobile ? "" : "thumbs",
                navpanes: 0,
                toolbar: 0,
                statusbar: 0,
                view: "FitH"
              },
              page: 1,
              forcePDFJS: true,
              PDFJS_URL: self.PDFJS_URL
            };
            //console.log(this.file.link);
            this.$nextTick(() => {
              PDFObject.embed(
                this.file.link,
                `#pdf_${this.propFileId}`,
                options
              );
            });
          }
        }
      );
    }
  }
};
</script>
